import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

function TableCommonRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { displayChannel, maxRevenue, shareData, showModal, stores, structure, type } = data
  const showStoreChannel = type === 'group' || displayChannel
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const percentOfMaxRevenue = Math.round((100 * store.revenueCurrent) / maxRevenue)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${percentOfMaxRevenue}%` }} />

        {structure.map(props => {
          const { RowRenderer, classNameRow, id } = props

          return (
            <div className={classNames(`cell-${id}`, classNameRow)} key={id}>
              {RowRenderer && (
                <RowRenderer
                  {...props}
                  displayChannel={showStoreChannel}
                  maxRevenue={maxRevenue}
                  shareData={shareData}
                  showModal={showModal}
                  store={store}
                  t={translate}
                />
              )}
            </div>
          )
        })}
      </div>
    </Box>
  )
}

TableCommonRow.propTypes = {
  data: PropTypes.shape({
    maxRevenue: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableCommonRow
